export default class ElementReversibleAction<ActionReturnType, ReverseActionReturnType> {
  name!: string
  action!: () => Promise<ActionReturnType>
  reverseAction!: () => Promise<ReverseActionReturnType>
  actionResult?: ActionReturnType
  reverseActionResult?: ActionReturnType
}
